import { render, staticRenderFns } from "./LaborCalendar.vue?vue&type=template&id=5368cd92&scoped=true&"
import script from "./LaborCalendar.vue?vue&type=script&lang=ts&"
export * from "./LaborCalendar.vue?vue&type=script&lang=ts&"
import style0 from "./LaborCalendar.vue?vue&type=style&index=0&id=5368cd92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5368cd92",
  null
  
)

export default component.exports